const initState = {
    activities: {
        workFlowActivities: [],
        /**control */
        connection: false,
        error: false,
        message: "",
    },

    states: {
        workFlowStates: [],
        /**control */
        connection: false,
        error: false,
        message: "",
    },
    
    workFlow: {
        workFlowList: [],
        /**control */
        connection: false,
        error: false,
        message: "",
    }





};

export default initState;